import cx from 'classnames';
import React from 'react';

export const Sizes = {
  Small: 'small',
  Medium: 'medium',
  Big: 'big',
};

const Size = ({ value, onChange }) => {
  return (
    <div className="flex flex-col gap-2">
      <span className="text-[10px] text-[#171717]">SIZE</span>
      <div
        className="grid rounded"
        style={{
          padding: 2,
          backgroundColor: '#F5F5F5',
          gridTemplateColumns: '1fr 1fr 1fr',
        }}
      >
        <div
          className={cx('flex justify-center items-center h-9 cursor-pointer rounded border-r', {
            'bg-white': value === Sizes.Small,
          })}
          onClick={onChange?.bind(null, Sizes.Small)}
        >
          Small
        </div>
        <div
          className={cx('flex justify-center items-center h-9 cursor-pointer rounded border-r', {
            'bg-white': value === Sizes.Medium,
          })}
          onClick={onChange?.bind(null, Sizes.Medium)}
        >
          Medium
        </div>
        <div
          className={cx('flex justify-center items-center h-9 cursor-pointer rounded', {
            'bg-white': value === Sizes.Big,
          })}
          onClick={onChange?.bind(null, Sizes.Big)}
        >
          Big
        </div>
      </div>
    </div>
  );
};

export default Size;
